import { raykouApi } from '@utils/axios';


export const getPermissions = async (companyId: string) => {
  try {
    const res = await raykouApi.get(`/subscriptions/permissions/${companyId}`);

    return res.data;
  } catch (error) {

    return [];
  }
};

